import * as React from "react";
import { forwardRef } from "react";
const SvgComponent = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", Object.assign({
  viewBox: "0 0 24 25",
  fill: "currentColor",
  "aria-hidden": "true",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, /*#__PURE__*/React.createElement("path", {
  d: "M19.69 20.585H4.31c-1.69 0-3.06-1.29-3.06-2.88v-9.94c0-1.59 1.37-2.88 3.06-2.88h15.38c1.69 0 3.06 1.29 3.06 2.88v9.94c0 1.59-1.37 2.88-3.06 2.88M4.31 6.385c-.86 0-1.56.62-1.56 1.38v9.94c0 .76.7 1.38 1.56 1.38h15.38c.86 0 1.56-.62 1.56-1.38v-9.94c0-.76-.7-1.38-1.56-1.38zM7 16.635H5.49v-5.91l-1.49.53v-1.41l2.86-1.21H7zm7-3.29c0 1.05-.17 1.86-.52 2.43s-.84.86-1.47.86-1.13-.29-1.48-.86-.52-1.38-.52-2.43v-1.42c0-1.05.17-1.86.52-2.43s.84-.86 1.48-.86 1.13.29 1.48.86.52 1.39.52 2.43v1.42zm-1.33-1.65c0-.56-.05-.98-.16-1.25q-.165-.42-.51-.42c-.345 0-.4.13-.5.39s-.16.65-.17 1.17v1.99c0 .58.05 1.01.16 1.28s.28.4.51.4.39-.13.5-.39.16-.68.17-1.24zm5.99-3.81c-.02.41-.06.75-.15.97-.11.26-.27.39-.5.39s-.4-.13-.51-.4q-.135-.33-.15-.96h-1.32c.05.78.21 1.42.5 1.89.35.57.84.86 1.48.86s1.12-.29 1.47-.86c.29-.47.45-1.1.5-1.89zm-.67 9.7h1.51v-5.75h-.14l-2.86 1.21v1.41l1.49-.53z"
}));
const ForwardRef = forwardRef(SvgComponent);
export const OdometerIcon = ForwardRef;